<template>
  <v-container fluid tag="section">
    <div v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <v-card-text class="pb-0 pt-0" v-for="(itm,idx) in item" :key="idx">
      <v-divider v-if="idx !== 0" class="my-4"></v-divider>
      <v-chip :color="itm.order === null ? 'primary' : itm.order.auditStatus | formatAuditColor" small class="mr-3" outlined>
        {{itm.followTypeDic.name}}{{itm.order !== null ? `---${itm.order.auditStatusVal}` : '' }}
      </v-chip>
      <div class="size-15 my-3">
        <span v-if="itm.order !== null">
          {{itm.followTime | formatDate}}~{{itm.endTime | formatDate}}
        </span>
        <span v-else>
          {{itm.followTimeStr}}
        </span>
      </div>
      <p :class="`${$isMobile ? 'size-14' : 'text-h6'} text--primary`">
        客户联系人：<span small class="mt-n1 blue--text" outlined>{{itm.contactsPerson === null || itm.contactsPerson === undefined ? '--' : itm.contactsPerson.name}}</span> |
        跟进人：<span small class="mt-n1 pink--text" outlined>{{itm.createUser.name}}</span>
      </p>
      <div  class="text--primary my-3">
        跟进内容：<span :class="`${$isMobile ? 'size-12' : ''} font-weight-black`">{{itm.content}}</span>
      </div>
    </v-card-text>
  </v-container>
</template>

<script>
  export default {
    name: 'CustomerDetail',
    components: {
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      }
    },
    data() {
      return {
        form: {
          id: '',
          result: ''
        }
      }
    }
  }
</script>

<style>
</style>
